export default function() {
  window.addEventListener('load', () => {
    const parentMenus = document.querySelectorAll(
      '.mobile-menu .menu-item-has-children > a'
    );

    parentMenus.forEach(parentMenu => {
      parentMenu.insertAdjacentHTML(
        'afterend',
        '<span class="navigation--arrow"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg></span>'
      );
    });

    const arrows = document.querySelectorAll('.navigation--arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        arrow.parentElement.classList.toggle('active');
      });
    });
    /*
    $('.menu-item-has-children .arrow').click(function() {
      if ($(this.parentElement).hasClass('active')) {
        $('.menu-item-has-children.active').removeClass('active'); // Just remove class from all folder
      } else {
        $('.menu-item-has-children.active').removeClass('active');
        $(this.parentElement).addClass('active'); // add onto current
      }
    });*/
  });
}
